// Copied and modified from
// https://github.com/kyamagu/js-segment-annotator/blob/master/js/image/layer.js#L171
// at 23288e5b991371919c619729fe21fe5a4e68338a
// No changes to algorithm, just converted to typescript and changed to
// return the boundary mask instead of setting it on the global state

import { SuperpixelAlgorithmResult } from './superpixel-algorithm-result';

// eslint-disable-next-line max-lines-per-function,complexity -- if you need to modify this code, fix this first
export function toBoundaryMask(algorithmResult: SuperpixelAlgorithmResult) {
  const superpixelMap = algorithmResult.data;
  const width = algorithmResult.width;
  const height = algorithmResult.height;
  const foreground = [255, 255, 255, 127];
  const background = [0, 0, 0, 0];
  const boundaryMask = new Uint8ClampedArray(superpixelMap);
  for (let i = 0; i < height; ++i) {
    for (let j = 0; j < width; ++j) {
      const offset = 4 * (i * width + j);
      const index = superpixelMap[4 * (i * width + j)];
      const isBoundary =
        i === 0 ||
        j === 0 ||
        i === height - 1 ||
        j === width - 1 ||
        index !== superpixelMap[4 * (i * width + j - 1)] ||
        index !== superpixelMap[4 * (i * width + j + 1)] ||
        index !== superpixelMap[4 * ((i - 1) * width + j)] ||
        index !== superpixelMap[4 * ((i + 1) * width + j)];
      if (isBoundary) {
        for (let k = 0; k < foreground.length; ++k) {
          boundaryMask[offset + k] = foreground[k];
        }
      } else {
        for (let k = 0; k < background.length; ++k) {
          boundaryMask[offset + k] = background[k];
        }
      }
    }
  }
  return boundaryMask;
}
